import * as Schema from 'nutshell-core/schema';

const industries_enum = [
    {id: 'accounting', type: 'string', name: 'Accounting'},
    {id: 'airlines/aviation', type: 'string', name: 'Airlines/Aviation'},
    {id: 'alternative dispute resolution', type: 'string', name: 'Alternative Dispute Resolution'},
    {id: 'alternative medicine', type: 'string', name: 'Alternative Medicine'},
    {id: 'animation', type: 'string', name: 'Animation'},
    {id: 'apparel & fashion', type: 'string', name: 'Apparel & Fashion'},
    {id: 'architecture & planning', type: 'string', name: 'Architecture & Planning'},
    {id: 'arts and crafts', type: 'string', name: 'Arts and Crafts'},
    {id: 'automotive', type: 'string', name: 'Automotive'},
    {id: 'aviation & aerospace', type: 'string', name: 'Aviation & Aerospace'},
    {id: 'banking', type: 'string', name: 'Banking'},
    {id: 'biotechnology', type: 'string', name: 'Biotechnology'},
    {id: 'broadcast media', type: 'string', name: 'Broadcast Media'},
    {id: 'building materials', type: 'string', name: 'Building Materials'},
    {
        id: 'business supplies and equipment',
        type: 'string',
        name: 'Business Supplies and Equipment',
    },
    {id: 'capital markets', type: 'string', name: 'Capital Markets'},
    {id: 'chemicals', type: 'string', name: 'Chemicals'},
    {id: 'civic & social organization', type: 'string', name: 'Civic & Social Organization'},
    {id: 'civil engineering', type: 'string', name: 'Civil Engineering'},
    {id: 'commercial real estate', type: 'string', name: 'Commercial Real Estate'},
    {id: 'computer & network security', type: 'string', name: 'Computer & Network Security'},
    {id: 'computer games', type: 'string', name: 'Computer Games'},
    {id: 'computer hardware', type: 'string', name: 'Computer Hardware'},
    {id: 'computer networking', type: 'string', name: 'Computer Networking'},
    {id: 'computer software', type: 'string', name: 'Computer Software'},
    {id: 'construction', type: 'string', name: 'Construction'},
    {id: 'consumer electronics', type: 'string', name: 'Consumer Electronics'},
    {id: 'consumer goods', type: 'string', name: 'Consumer Goods'},
    {id: 'consumer services', type: 'string', name: 'Consumer Services'},
    {id: 'cosmetics', type: 'string', name: 'Cosmetics'},
    {id: 'dairy', type: 'string', name: 'Dairy'},
    {id: 'defense & space', type: 'string', name: 'Defense & Space'},
    {id: 'design', type: 'string', name: 'Design'},
    {id: 'e-learning', type: 'string', name: 'E-Learning'},
    {id: 'education management', type: 'string', name: 'Education Management'},
    {
        id: 'electrical/electronic manufacturing',
        type: 'string',
        name: 'Electrical/Electronic Manufacturing',
    },
    {id: 'entertainment', type: 'string', name: 'Entertainment'},
    {id: 'environmental services', type: 'string', name: 'Environmental Services'},
    {id: 'events services', type: 'string', name: 'Events Services'},
    {id: 'executive office', type: 'string', name: 'Executive Office'},
    {id: 'facilities services', type: 'string', name: 'Facilities Services'},
    {id: 'farming', type: 'string', name: 'Farming'},
    {id: 'financial services', type: 'string', name: 'Financial Services'},
    {id: 'fine art', type: 'string', name: 'Fine Art'},
    {id: 'fishery', type: 'string', name: 'Fishery'},
    {id: 'food & beverages', type: 'string', name: 'Food & Beverages'},
    {id: 'food production', type: 'string', name: 'Food Production'},
    {id: 'fund-raising', type: 'string', name: 'Fund-Raising'},
    {id: 'furniture', type: 'string', name: 'Furniture'},
    {id: 'gambling & casinos', type: 'string', name: 'Gambling & Casinos'},
    {id: 'glass, ceramics & concrete', type: 'string', name: 'Glass, Ceramics & Concrete'},
    {id: 'government administration', type: 'string', name: 'Government Administration'},
    {id: 'government relations', type: 'string', name: 'Government Relations'},
    {id: 'graphic design', type: 'string', name: 'Graphic Design'},
    {id: 'health, wellness and fitness', type: 'string', name: 'Health, Wellness and Fitness'},
    {id: 'higher education', type: 'string', name: 'Higher Education'},
    {id: 'hospital & health care', type: 'string', name: 'Hospital & Health Care'},
    {id: 'hospitality', type: 'string', name: 'Hospitality'},
    {id: 'human resources', type: 'string', name: 'Human Resources'},
    {id: 'import and export', type: 'string', name: 'Import and Export'},
    {id: 'individual & family services', type: 'string', name: 'Individual & Family Services'},
    {id: 'industrial automation', type: 'string', name: 'Industrial Automation'},
    {id: 'information services', type: 'string', name: 'Information Services'},
    {
        id: 'information technology and services',
        type: 'string',
        name: 'Information Technology and Services',
    },
    {id: 'insurance', type: 'string', name: 'Insurance'},
    {id: 'international affairs', type: 'string', name: 'International Affairs'},
    {
        id: 'international trade and development',
        type: 'string',
        name: 'International Trade and Development',
    },
    {id: 'internet', type: 'string', name: 'Internet'},
    {id: 'investment banking', type: 'string', name: 'Investment Banking'},
    {id: 'investment management', type: 'string', name: 'Investment Management'},
    {id: 'judiciary', type: 'string', name: 'Judiciary'},
    {id: 'law enforcement', type: 'string', name: 'Law Enforcement'},
    {id: 'law practice', type: 'string', name: 'Law Practice'},
    {id: 'legal services', type: 'string', name: 'Legal Services'},
    {id: 'legislative office', type: 'string', name: 'Legislative Office'},
    {id: 'leisure, travel & tourism', type: 'string', name: 'Leisure, Travel & Tourism'},
    {id: 'libraries', type: 'string', name: 'Libraries'},
    {id: 'logistics and supply chain', type: 'string', name: 'Logistics and Supply Chain'},
    {id: 'luxury goods & jewelry', type: 'string', name: 'Luxury Goods & Jewelry'},
    {id: 'machinery', type: 'string', name: 'Machinery'},
    {id: 'management consulting', type: 'string', name: 'Management Consulting'},
    {id: 'maritime', type: 'string', name: 'Maritime'},
    {id: 'market research', type: 'string', name: 'Market Research'},
    {id: 'marketing and advertising', type: 'string', name: 'Marketing and Advertising'},
    {
        id: 'mechanical or industrial engineering',
        type: 'string',
        name: 'Mechanical or Industrial Engineering',
    },
    {id: 'media production', type: 'string', name: 'Media Production'},
    {id: 'medical devices', type: 'string', name: 'Medical Devices'},
    {id: 'medical practice', type: 'string', name: 'Medical Practice'},
    {id: 'mental health care', type: 'string', name: 'Mental Health Care'},
    {id: 'military', type: 'string', name: 'Military'},
    {id: 'mining & metals', type: 'string', name: 'Mining & Metals'},
    {id: 'motion pictures and film', type: 'string', name: 'Motion Pictures and Film'},
    {id: 'museums and institutions', type: 'string', name: 'Museums and Institutions'},
    {id: 'music', type: 'string', name: 'Music'},
    {id: 'nanotechnology', type: 'string', name: 'Nanotechnology'},
    {id: 'newspapers', type: 'string', name: 'Newspapers'},
    {
        id: 'non-profit organization management',
        type: 'string',
        name: 'Non-Profit Organization Management',
    },
    {id: 'oil & energy', type: 'string', name: 'Oil & Energy'},
    {id: 'online media', type: 'string', name: 'Online Media'},
    {id: 'outsourcing/offshoring', type: 'string', name: 'Outsourcing/Offshoring'},
    {id: 'package/freight delivery', type: 'string', name: 'Package/Freight Delivery'},
    {id: 'packaging and containers', type: 'string', name: 'Packaging and Containers'},
    {id: 'paper & forest products', type: 'string', name: 'Paper & Forest Products'},
    {id: 'performing arts', type: 'string', name: 'Performing Arts'},
    {id: 'pharmaceuticals', type: 'string', name: 'Pharmaceuticals'},
    {id: 'philanthropy', type: 'string', name: 'Philanthropy'},
    {id: 'photography', type: 'string', name: 'Photography'},
    {id: 'plastics', type: 'string', name: 'Plastics'},
    {id: 'political organization', type: 'string', name: 'Political Organization'},
    {id: 'primary/secondary education', type: 'string', name: 'Primary/Secondary Education'},
    {id: 'printing', type: 'string', name: 'Printing'},
    {
        id: 'professional training & coaching',
        type: 'string',
        name: 'Professional Training & Coaching',
    },
    {id: 'program development', type: 'string', name: 'Program Development'},
    {id: 'public policy', type: 'string', name: 'Public Policy'},
    {
        id: 'public relations and communications',
        type: 'string',
        name: 'Public Relations and Communications',
    },
    {id: 'public safety', type: 'string', name: 'Public Safety'},
    {id: 'publishing', type: 'string', name: 'Publishing'},
    {id: 'railroad manufacture', type: 'string', name: 'Railroad Manufacture'},
    {id: 'ranching', type: 'string', name: 'Ranching'},
    {id: 'real estate', type: 'string', name: 'Real Estate'},
    {
        id: 'recreational facilities and services',
        type: 'string',
        name: 'Recreational Facilities and Services',
    },
    {id: 'religious institutions', type: 'string', name: 'Religious Institutions'},
    {id: 'renewables & environment', type: 'string', name: 'Renewables & Environment'},
    {id: 'research', type: 'string', name: 'Research'},
    {id: 'restaurants', type: 'string', name: 'Restaurants'},
    {id: 'retail', type: 'string', name: 'Retail'},
    {id: 'security and investigations', type: 'string', name: 'Security and Investigations'},
    {id: 'semiconductors', type: 'string', name: 'Semiconductors'},
    {id: 'shipbuilding', type: 'string', name: 'Shipbuilding'},
    {id: 'sporting goods', type: 'string', name: 'Sporting Goods'},
    {id: 'sports', type: 'string', name: 'Sports'},
    {id: 'staffing and recruiting', type: 'string', name: 'Staffing and Recruiting'},
    {id: 'supermarkets', type: 'string', name: 'Supermarkets'},
    {id: 'telecommunications', type: 'string', name: 'Telecommunications'},
    {id: 'textiles', type: 'string', name: 'Textiles'},
    {id: 'think tanks', type: 'string', name: 'Think Tanks'},
    {id: 'tobacco', type: 'string', name: 'Tobacco'},
    {id: 'translation and localization', type: 'string', name: 'Translation and Localization'},
    {
        id: 'transportation/trucking/railroad',
        type: 'string',
        name: 'Transportation/Trucking/Railroad',
    },
    {id: 'utilities', type: 'string', name: 'Utilities'},
    {
        id: 'venture capital & private equity',
        type: 'string',
        name: 'Venture Capital & Private Equity',
    },
    {id: 'veterinary', type: 'string', name: 'Veterinary'},
    {id: 'warehousing', type: 'string', name: 'Warehousing'},
    {id: 'wholesale', type: 'string', name: 'Wholesale'},
    {id: 'wine and spirits', type: 'string', name: 'Wine and Spirits'},
    {id: 'wireless', type: 'string', name: 'Wireless'},
    {id: 'writing and editing', type: 'string', name: 'Writing and Editing'},
];

export const drawerFields: Schema.FieldProperties[] = [
    {
        bucket: 'Person fields',
        type: 'string',
        title: 'Person name',
        description: 'Name of the person',
        isFilterable: true,
        isDisplayable: true,
        // @ts-expect-error
        isAddable: true,
        isRemoveable: true,
        isSortable: false,
        isGoalable: false,
        isSimple: true,
        size: 'md',
        name: 'personName',
    },
    {
        bucket: 'Settings',
        type: 'boolean',
        title: 'Must have email',
        description: 'Whether the person has an email',
        isFilterable: true,
        isDisplayable: true,
        isSortable: false,
        isFalseable: false,
        size: 'md',
        name: 'hasEmail',
    },
    {
        bucket: 'Settings',
        type: 'boolean',
        title: 'Must have phone number',
        description: 'Whether the person has a phone number',
        isFilterable: true,
        isDisplayable: true,
        // @ts-expect-error
        isAddable: true,
        isRemoveable: true,
        isSortable: false,
        isGoalable: false,
        isFalseable: false,
        size: 'md',
        name: 'hasPhoneNumber',
    },
    {
        bucket: 'Settings',
        type: 'boolean',
        title: 'Must have LinkedIn',
        description: 'Whether the person has a LinkedIn profile',
        isFilterable: true,
        isDisplayable: true,
        // @ts-expect-error
        isAddable: true,
        isRemoveable: true,
        isSortable: false,
        isGoalable: false,
        isFalseable: false,
        size: 'md',
        name: 'hasLinkedin',
    },
    {
        bucket: 'Person fields',
        type: 'enum',
        enum: [
            {
                id: 'customer_service',
                type: 'string',
                name: 'Customer Service',
            },
            {
                id: 'design',
                type: 'string',
                name: 'Design',
            },
            {
                id: 'education',
                type: 'string',
                name: 'Education',
            },
            {
                id: 'engineering',
                type: 'string',
                name: 'Engineering',
            },
            {
                id: 'finance',
                type: 'string',
                name: 'Finance',
            },
            {
                id: 'health',
                type: 'string',
                name: 'Health',
            },
            {
                id: 'human_resources',
                type: 'string',
                name: 'Human Resources',
            },
            {
                id: 'legal',
                type: 'string',
                name: 'Legal',
            },
            {
                id: 'marketing',
                type: 'string',
                name: 'Marketing',
            },
            {
                id: 'media',
                type: 'string',
                name: 'Media',
            },
            {
                id: 'operations',
                type: 'string',
                name: 'Operations',
            },
            {
                id: 'public_relations',
                type: 'string',
                name: 'Public Relations',
            },
            {
                id: 'real_estate',
                type: 'string',
                name: 'Real Estate',
            },
            {
                id: 'sales',
                type: 'string',
                name: 'Sales',
            },
            {
                id: 'trades',
                type: 'string',
                name: 'Trades',
            },
        ],
        title: 'Job role',
        description: 'Job role of the person',
        isFilterable: true,
        isDisplayable: true,
        isSortable: false,
        isAndable: false,
        allowAny: false,
        size: 'md',
        name: 'role',
    },
    {
        bucket: 'Person fields',
        type: 'enum',
        enum: [
            {
                id: 'cxo',
                type: 'string',
                name: 'C-level',
            },
            {
                id: 'director',
                type: 'string',
                name: 'Director',
            },
            {
                id: 'entry',
                type: 'string',
                name: 'Entry',
            },
            {
                id: 'manager',
                type: 'string',
                name: 'Manager',
            },
            {
                id: 'owner',
                type: 'string',
                name: 'Owner',
            },
            {
                id: 'partner',
                type: 'string',
                name: 'Partner',
            },
            {
                id: 'senior',
                type: 'string',
                name: 'Senior',
            },
            {
                id: 'training',
                type: 'string',
                name: 'Training',
            },
            {
                id: 'unpaid',
                type: 'string',
                name: 'Unpaid',
            },
            {
                id: 'vp',
                type: 'string',
                name: 'VP',
            },
        ],
        title: 'Job level',
        description: 'Job level of the person',
        isFilterable: false,
        isDisplayable: false,
        isSortable: false,
        isAndable: false,
        allowAny: false,
        size: 'md',
        name: 'level',
    },
    {
        bucket: 'Company fields',
        type: 'string',
        title: 'Company name',
        description: 'Name of the company',
        isFilterable: true,
        isDisplayable: true,
        // @ts-expect-error
        isAddable: true,
        isRemoveable: true,
        isSortable: false,
        isGoalable: false,
        isSimple: true,
        size: 'md',
        name: 'companyName',
    },
    {
        bucket: 'Company fields',
        type: 'enum',
        title: 'Industry',
        isAndable: false,
        enum: industries_enum,
        description: 'Industry of the company',
        isFilterable: true,
        isDisplayable: true,
        // @ts-expect-error
        isAddable: true,
        isRemoveable: true,
        isSortable: false,
        isGoalable: false,
        size: 'md',
        name: 'industry',
        allowAny: false,
    },
    {
        bucket: 'Company fields',
        type: 'location',
        title: 'Location',
        description: 'Location of the company',
        isFilterable: true,
        isDisplayable: true,
        // @ts-expect-error
        isAddable: true,
        isRemoveable: true,
        isSortable: false,
        isGoalable: false,
        size: 'md',
        name: 'location',
        isNewLocationField: true,
        useProspectorStateSelector: true,
    },
    {
        bucket: 'Company fields',
        type: 'enum',
        title: 'Company size',
        description: 'Size of the company in terms of employee count',
        enum: [
            {id: '1', type: 'number', name: '1-10'},
            {id: '11', type: 'number', name: '11-50'},
            {id: '51', type: 'number', name: '51-200'},
            {id: '201', type: 'number', name: '201-500'},
            {id: '501', type: 'number', name: '501-1,000'},
            {id: '1001', type: 'number', name: '1,001-5,000'},
            {id: '5001', type: 'number', name: '5,001-10,000'},
            {id: '10001', type: 'number', name: '10,001+'},
        ],
        isFilterable: true,
        isDisplayable: true,
        isSortable: false,
        // @ts-expect-error
        isGoalable: false,
        isAndable: false,
        size: 'md',
        name: 'size',
        allowAny: false,
    },
    {
        bucket: 'Company fields',
        type: 'enum',
        title: 'Company revenue',
        description: 'Revenue of the company',
        enum: [
            {id: '1', type: 'number', name: '$1-$1m'},
            {id: '1000001', type: 'number', name: '$1m-$5m'},
            {id: '5000001', type: 'number', name: '$5m-$10m'},
            {id: '10000001', type: 'number', name: '$10m-$50m'},
            {id: '50000001', type: 'number', name: '$50m-$100m'},
            {id: '100000001', type: 'number', name: '$100m-$250m'},
            {id: '250000001', type: 'number', name: '$250m-$500m'},
            {id: '500000001', type: 'number', name: '$500m-$1b'},
            {id: '1000000001', type: 'number', name: '$1b+'},
        ],
        isFilterable: true,
        isDisplayable: true,
        isSortable: false,
        // @ts-expect-error
        isGoalable: false,
        isAndable: false,
        size: 'md',
        name: 'revenue',
    },
];
